import React, { Component } from 'react';
import 'react-phone-input-2/lib/style.css';
import { Modal, Form, Button } from 'react-bootstrap';
import { GoAlert } from "react-icons/go";
import './blue-page-modal.css';

export default class SubDomain extends Component {
    render() {
        const landingUrl = this.props.landingUrl;
        return (
            <Modal show={this.props.showModal} onHide={this.props.hideModal} className="commonModal bluePageModal">
                <Modal.Body className='modalBody'>

                    <div className='alertWrap'>
                        <div>
                            <div className='alertIcon'>
                            <GoAlert/>
                        </div>
                   
                        <div className='alertText'>
                            <h1>You have been Phished!</h1>
                            <p>You just fell for a phishing simulation. 
                                Click below to begin your cybersecurity 
                                awareness training course.</p>
                        </div>
                        </div>
                       
                     </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn closeBtn' onClick={this.props.hideModal}>Close</Button>
                    <Button className='btn btn-primary' onClick={this.props.redirectToInstantAwareness}>Start course</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}